// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Onboarding público — design limpo, mobile-first */
.onb-shell {
    min-height: 100vh;
    background: linear-gradient(135deg, #f5f7fa 0%, #e8edf3 100%);
    padding: 20px 16px 60px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    color: #1f2937;
}
.onb-card {
    max-width: 720px;
    margin: 0 auto;
    background: #ffffff;
    border-radius: 14px;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
    overflow: hidden;
}
.onb-header {
    background: linear-gradient(135deg, #1e3a8a, #2563eb);
    color: #ffffff;
    padding: 28px 24px;
    text-align: center;
}
.onb-header h1 { margin: 0 0 6px; font-size: 1.4rem; font-weight: 700; }
.onb-header p { margin: 0; opacity: 0.9; font-size: 0.92rem; }

.onb-body { padding: 24px 22px; }
.onb-section { margin-bottom: 26px; }
.onb-section-title {
    font-size: 0.95rem;
    font-weight: 700;
    color: #1e3a8a;
    margin: 0 0 12px;
    padding-bottom: 6px;
    border-bottom: 2px solid #e0e7ff;
}
.onb-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
}
.onb-field { display: flex; flex-direction: column; gap: 4px; }
.onb-field.full { grid-column: 1 / -1; }
.onb-field label {
    font-size: 0.78rem;
    font-weight: 600;
    color: #4b5563;
    text-transform: uppercase;
    letter-spacing: 0.3px;
}
.onb-field input, .onb-field select, .onb-field textarea {
    padding: 10px 12px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    font-size: 0.95rem;
    background: #ffffff;
    transition: border-color 0.15s, box-shadow 0.15s;
}
.onb-field input:focus, .onb-field select:focus, .onb-field textarea:focus {
    outline: none;
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
}

.onb-photo-row {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
}
.onb-photo-preview {
    width: 110px;
    height: 110px;
    border-radius: 50%;
    border: 3px dashed #d1d5db;
    background: #f9fafb;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}
.onb-photo-preview img { width: 100%; height: 100%; object-fit: cover; }
.onb-photo-actions { display: flex; flex-direction: column; gap: 8px; }

.onb-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 10px 16px;
    border: none;
    border-radius: 8px;
    font-size: 0.9rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s;
}
.onb-btn-primary { background: #2563eb; color: #fff; }
.onb-btn-primary:hover { background: #1d4ed8; }
.onb-btn-secondary { background: #f3f4f6; color: #1f2937; border: 1px solid #d1d5db; }
.onb-btn-secondary:hover { background: #e5e7eb; }
.onb-btn-success { background: #16a34a; color: #fff; }
.onb-btn-success:hover { background: #15803d; }
.onb-btn:disabled { opacity: 0.5; cursor: not-allowed; }

.onb-sig-canvas-wrap {
    position: relative;
    background: #fff;
    border: 2px dashed #d1d5db;
    border-radius: 10px;
    overflow: hidden;
    touch-action: none;
}
.onb-sig-canvas { display: block; width: 100%; height: 200px; cursor: crosshair; }
.onb-sig-preview {
    background: #f9fafb;
    border: 1px solid #d1d5db;
    border-radius: 10px;
    padding: 12px;
    text-align: center;
}
.onb-sig-preview img {
    max-width: 100%;
    max-height: 140px;
    background: #fff;
}
.onb-sig-actions { display: flex; gap: 8px; flex-wrap: wrap; margin-top: 10px; }

.onb-tabs { display: flex; gap: 6px; margin-bottom: 12px; flex-wrap: wrap; }
.onb-tab {
    padding: 8px 14px;
    border: 1px solid #d1d5db;
    border-radius: 999px;
    background: #f9fafb;
    cursor: pointer;
    font-size: 0.85rem;
    color: #4b5563;
}
.onb-tab.active { background: #2563eb; color: #fff; border-color: #2563eb; }

.onb-checkbox {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    background: #f9fafb;
    padding: 12px 14px;
    border-radius: 8px;
    border: 1px solid #e5e7eb;
}
.onb-checkbox input { margin-top: 3px; width: 18px; height: 18px; }
.onb-checkbox label { font-size: 0.9rem; line-height: 1.4; color: #1f2937; }

.onb-footer {
    border-top: 1px solid #e5e7eb;
    padding: 18px 22px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    flex-wrap: wrap;
}
.onb-msg-error {
    background: #fee2e2;
    color: #991b1b;
    padding: 10px 14px;
    border-radius: 8px;
    margin-bottom: 14px;
    font-size: 0.88rem;
}
.onb-msg-success {
    background: #dcfce7;
    color: #14532d;
    padding: 14px;
    border-radius: 8px;
    text-align: center;
    font-weight: 600;
}
.onb-loading { text-align: center; padding: 60px 20px; color: #6b7280; }
.onb-error-screen {
    text-align: center;
    padding: 60px 20px;
    color: #991b1b;
    font-size: 1.05rem;
}


.onb-mobile-manuals-note {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin: 16px 0;
    padding: 14px 16px;
    border: 1px solid #bfdbfe;
    border-radius: 12px;
    background: linear-gradient(135deg, #eff6ff, #f8fbff);
    color: #1e3a5f;
    box-shadow: 0 1px 2px rgba(30, 64, 175, 0.06);
}
.onb-mobile-manuals-note-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 38px;
    width: 38px;
    height: 38px;
    border-radius: 10px;
    background: #dbeafe;
    color: #2563eb;
}
.onb-mobile-manuals-note strong {
    display: block;
    color: #1e3a5f;
    font-size: 0.9rem;
}
.onb-mobile-manuals-note p {
    margin: 4px 0 0;
    color: #475569;
    font-size: 0.82rem;
    line-height: 1.5;
}

@media (max-width: 600px) {
    .onb-grid { grid-template-columns: 1fr; }
    .onb-header h1 { font-size: 1.2rem; }
    .onb-body { padding: 18px 14px; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/OnboardingTrabalhador.css"],"names":[],"mappings":"AAAA,oDAAoD;AACpD;IACI,iBAAiB;IACjB,6DAA6D;IAC7D,uBAAuB;IACvB,8EAA8E;IAC9E,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,0CAA0C;IAC1C,gBAAgB;AACpB;AACA;IACI,qDAAqD;IACrD,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;AACA,iBAAiB,eAAe,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AACvE,gBAAgB,SAAS,EAAE,YAAY,EAAE,kBAAkB,EAAE;;AAE7D,YAAY,kBAAkB,EAAE;AAChC,eAAe,mBAAmB,EAAE;AACpC;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;AACpC;AACA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;AACA,aAAa,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC9D,kBAAkB,mBAAmB,EAAE;AACvC;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,gDAAgD;AACpD;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;AACA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,0BAA0B;IAC1B,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;AACA,yBAAyB,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE;AACvE,qBAAqB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;;AAEtE;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,qBAAqB;AACzB;AACA,mBAAmB,mBAAmB,EAAE,WAAW,EAAE;AACrD,yBAAyB,mBAAmB,EAAE;AAC9C,qBAAqB,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;AACrF,2BAA2B,mBAAmB,EAAE;AAChD,mBAAmB,mBAAmB,EAAE,WAAW,EAAE;AACrD,yBAAyB,mBAAmB,EAAE;AAC9C,oBAAoB,YAAY,EAAE,mBAAmB,EAAE;;AAEvD;IACI,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;AACA,kBAAkB,cAAc,EAAE,WAAW,EAAE,aAAa,EAAE,iBAAiB,EAAE;AACjF;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;AACA,mBAAmB,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE,gBAAgB,EAAE;;AAE/E,YAAY,aAAa,EAAE,QAAQ,EAAE,mBAAmB,EAAE,eAAe,EAAE;AAC3E;IACI,iBAAiB;IACjB,yBAAyB;IACzB,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;AACA,kBAAkB,mBAAmB,EAAE,WAAW,EAAE,qBAAqB,EAAE;;AAE3E;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;AAC7B;AACA,sBAAsB,eAAe,EAAE,WAAW,EAAE,YAAY,EAAE;AAClE,sBAAsB,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE;;AAE3E;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;AACA,eAAe,kBAAkB,EAAE,kBAAkB,EAAE,cAAc,EAAE;AACvE;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;;AAGA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,qDAAqD;IACrD,cAAc;IACd,6CAA6C;AACjD;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,cAAc;IACd,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY,0BAA0B,EAAE;IACxC,iBAAiB,iBAAiB,EAAE;IACpC,YAAY,kBAAkB,EAAE;AACpC","sourcesContent":["/* Onboarding público — design limpo, mobile-first */\n.onb-shell {\n    min-height: 100vh;\n    background: linear-gradient(135deg, #f5f7fa 0%, #e8edf3 100%);\n    padding: 20px 16px 60px;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n    color: #1f2937;\n}\n.onb-card {\n    max-width: 720px;\n    margin: 0 auto;\n    background: #ffffff;\n    border-radius: 14px;\n    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);\n    overflow: hidden;\n}\n.onb-header {\n    background: linear-gradient(135deg, #1e3a8a, #2563eb);\n    color: #ffffff;\n    padding: 28px 24px;\n    text-align: center;\n}\n.onb-header h1 { margin: 0 0 6px; font-size: 1.4rem; font-weight: 700; }\n.onb-header p { margin: 0; opacity: 0.9; font-size: 0.92rem; }\n\n.onb-body { padding: 24px 22px; }\n.onb-section { margin-bottom: 26px; }\n.onb-section-title {\n    font-size: 0.95rem;\n    font-weight: 700;\n    color: #1e3a8a;\n    margin: 0 0 12px;\n    padding-bottom: 6px;\n    border-bottom: 2px solid #e0e7ff;\n}\n.onb-grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 12px;\n}\n.onb-field { display: flex; flex-direction: column; gap: 4px; }\n.onb-field.full { grid-column: 1 / -1; }\n.onb-field label {\n    font-size: 0.78rem;\n    font-weight: 600;\n    color: #4b5563;\n    text-transform: uppercase;\n    letter-spacing: 0.3px;\n}\n.onb-field input, .onb-field select, .onb-field textarea {\n    padding: 10px 12px;\n    border: 1px solid #d1d5db;\n    border-radius: 8px;\n    font-size: 0.95rem;\n    background: #ffffff;\n    transition: border-color 0.15s, box-shadow 0.15s;\n}\n.onb-field input:focus, .onb-field select:focus, .onb-field textarea:focus {\n    outline: none;\n    border-color: #2563eb;\n    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);\n}\n\n.onb-photo-row {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    flex-wrap: wrap;\n}\n.onb-photo-preview {\n    width: 110px;\n    height: 110px;\n    border-radius: 50%;\n    border: 3px dashed #d1d5db;\n    background: #f9fafb;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n}\n.onb-photo-preview img { width: 100%; height: 100%; object-fit: cover; }\n.onb-photo-actions { display: flex; flex-direction: column; gap: 8px; }\n\n.onb-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    padding: 10px 16px;\n    border: none;\n    border-radius: 8px;\n    font-size: 0.9rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.15s;\n}\n.onb-btn-primary { background: #2563eb; color: #fff; }\n.onb-btn-primary:hover { background: #1d4ed8; }\n.onb-btn-secondary { background: #f3f4f6; color: #1f2937; border: 1px solid #d1d5db; }\n.onb-btn-secondary:hover { background: #e5e7eb; }\n.onb-btn-success { background: #16a34a; color: #fff; }\n.onb-btn-success:hover { background: #15803d; }\n.onb-btn:disabled { opacity: 0.5; cursor: not-allowed; }\n\n.onb-sig-canvas-wrap {\n    position: relative;\n    background: #fff;\n    border: 2px dashed #d1d5db;\n    border-radius: 10px;\n    overflow: hidden;\n    touch-action: none;\n}\n.onb-sig-canvas { display: block; width: 100%; height: 200px; cursor: crosshair; }\n.onb-sig-preview {\n    background: #f9fafb;\n    border: 1px solid #d1d5db;\n    border-radius: 10px;\n    padding: 12px;\n    text-align: center;\n}\n.onb-sig-preview img {\n    max-width: 100%;\n    max-height: 140px;\n    background: #fff;\n}\n.onb-sig-actions { display: flex; gap: 8px; flex-wrap: wrap; margin-top: 10px; }\n\n.onb-tabs { display: flex; gap: 6px; margin-bottom: 12px; flex-wrap: wrap; }\n.onb-tab {\n    padding: 8px 14px;\n    border: 1px solid #d1d5db;\n    border-radius: 999px;\n    background: #f9fafb;\n    cursor: pointer;\n    font-size: 0.85rem;\n    color: #4b5563;\n}\n.onb-tab.active { background: #2563eb; color: #fff; border-color: #2563eb; }\n\n.onb-checkbox {\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n    background: #f9fafb;\n    padding: 12px 14px;\n    border-radius: 8px;\n    border: 1px solid #e5e7eb;\n}\n.onb-checkbox input { margin-top: 3px; width: 18px; height: 18px; }\n.onb-checkbox label { font-size: 0.9rem; line-height: 1.4; color: #1f2937; }\n\n.onb-footer {\n    border-top: 1px solid #e5e7eb;\n    padding: 18px 22px;\n    display: flex;\n    justify-content: flex-end;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n.onb-msg-error {\n    background: #fee2e2;\n    color: #991b1b;\n    padding: 10px 14px;\n    border-radius: 8px;\n    margin-bottom: 14px;\n    font-size: 0.88rem;\n}\n.onb-msg-success {\n    background: #dcfce7;\n    color: #14532d;\n    padding: 14px;\n    border-radius: 8px;\n    text-align: center;\n    font-weight: 600;\n}\n.onb-loading { text-align: center; padding: 60px 20px; color: #6b7280; }\n.onb-error-screen {\n    text-align: center;\n    padding: 60px 20px;\n    color: #991b1b;\n    font-size: 1.05rem;\n}\n\n\n.onb-mobile-manuals-note {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    margin: 16px 0;\n    padding: 14px 16px;\n    border: 1px solid #bfdbfe;\n    border-radius: 12px;\n    background: linear-gradient(135deg, #eff6ff, #f8fbff);\n    color: #1e3a5f;\n    box-shadow: 0 1px 2px rgba(30, 64, 175, 0.06);\n}\n.onb-mobile-manuals-note-icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex: 0 0 38px;\n    width: 38px;\n    height: 38px;\n    border-radius: 10px;\n    background: #dbeafe;\n    color: #2563eb;\n}\n.onb-mobile-manuals-note strong {\n    display: block;\n    color: #1e3a5f;\n    font-size: 0.9rem;\n}\n.onb-mobile-manuals-note p {\n    margin: 4px 0 0;\n    color: #475569;\n    font-size: 0.82rem;\n    line-height: 1.5;\n}\n\n@media (max-width: 600px) {\n    .onb-grid { grid-template-columns: 1fr; }\n    .onb-header h1 { font-size: 1.2rem; }\n    .onb-body { padding: 18px 14px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
